import { isDevMode } from '@angular/core';

// https://developer.chrome.com/docs/devtools/console/format-style#style_console_messages
export function logColor(str: string, color: string, ...otherData: unknown[]): void {
  console.log(...createColorMessages(str, color), ...otherData);
}

export function createColorMessages(str: string, color: string): string[] {
  return [`%c${str}`, `color: ${color}`];
}

export class PrefixedLogger {
  private readonly _isDevMode = isDevMode();
  constructor(
    private prefix: string,
    private color: string,
  ) {}

  log(...otherData: unknown[]): void {
    logColor(this.prefix, this.color, ...otherData);
  }

  logDevMode(params: () => unknown[]): void {
    if (this._isDevMode) {
      this.log(...params());
    }
  }
}
